import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';

import { ExternalUnits, UnitConfigurationPerformanceData, UnitSimulationAccessory } from '../../models';
import { UnitConfigurationActions } from './unit-configuration.actions';
import { UNIT_CONFIGURATION_STATE_TOKEN, UnitConfigurationStateModel } from './unit-configuration.model';

const defaults: UnitConfigurationStateModel = {
  currentSimulationAccessories: undefined,
  updatingAccessories: false,
  performanceData: {
    accessories: [],
    messages: [],
    envelopes: [],
  },
  externalUnitContainer: {
    externalUnits: [],
    isLoading: false,
  },
};
@State<UnitConfigurationStateModel>({
  name: UNIT_CONFIGURATION_STATE_TOKEN,
  defaults,
})
@Injectable()
export class UnitConfigurationState {
  @Action(UnitConfigurationActions.SetSimulationAccessory)
  setSimulationAccessory(
    { patchState }: StateContext<UnitConfigurationStateModel>,
    { accessories }: UnitConfigurationActions.SetSimulationAccessory
  ) {
    patchState({ currentSimulationAccessories: accessories });
  }

  @Action(UnitConfigurationActions.SetUpdatingAccessories)
  setUpdatingAccessories(
    { patchState }: StateContext<UnitConfigurationStateModel>,
    { updating }: UnitConfigurationActions.SetUpdatingAccessories
  ) {
    patchState({ updatingAccessories: updating });
  }

  @Action(UnitConfigurationActions.ClearState)
  clearState({ setState }: StateContext<UnitConfigurationStateModel>) {
    setState(defaults);
  }

  @Action(UnitConfigurationActions.LoadExternalUnits)
  loadExternalUnits({ patchState, getState }: StateContext<UnitConfigurationStateModel>) {
    const patch = {
      externalUnitContainer: {
        isLoading: true,
        externalUnits: getState().externalUnitContainer.externalUnits,
      },
    };
    patchState(patch);
  }

  @Action(UnitConfigurationActions.SetExternalUnits)
  setExternalUnits(
    { patchState }: StateContext<UnitConfigurationStateModel>,
    { externalUnits }: UnitConfigurationActions.SetExternalUnits
  ) {
    const patch = {
      externalUnitContainer: {
        isLoading: false,
        externalUnits,
      },
    };
    patchState(patch);
  }

  @Action(UnitConfigurationActions.ResetExternalUnitsState)
  resetExternalUnitState({ getState, patchState }: StateContext<UnitConfigurationStateModel>) {
    const state = getState();

    patchState({
      externalUnitContainer: {
        isLoading: false,
        externalUnits: state.externalUnitContainer.externalUnits,
      },
    });
  }
}
